// extracted by css-extract-rspack-plugin
export default {"wrapper":"CliPrivateIcon-module__wrapper__unhv_","connectedDot":"CliPrivateIcon-module__connectedDot__PoBQ7"};